<template>
  <div>
    <Head title="Liquidación" />
    <div class="mb-6 flex">
      <h1 class="mb-5 text-3xl font-bold flex-auto">
        <Link class="text-sky-400 hover:text-sky-600" href="/liquidation">Liquidación</Link>
        <span class="text-sky-400 font-medium">/</span> Reporte
      </h1>
      <button
        class="px-4 py-3.5 bg-green-500 text-white rounded hover:bg-green-600 transition duration-300 text-end"
        @click="descargarPDF()"
      >
        Imprimir Reporte
      </button>
    </div>

    <!-- Contenedor principal -->
    <div class="max-w-7xl mx-auto bg-white rounded-lg shadow-lg p-6 space-y-6">
      <!-- Tabla General -->
      

      <!-- Tabla de Contado (purchase_type = 1) -->
      <div>
        <div class="flex">
          <h2 class="text-2xl font-semibold mb-4 flex-auto">Nota de Venta de Contado 16%</h2>
          <h2 class="text-2xl font-semibold mb-4 flex-auto text-end">
            Total: {{ formatCurrency(
              filteredData.map((item) => item.total_sales).reduce( (acc,curr) => acc + curr,0 ) 
            ) }}
          </h2>
        </div>
        
        <ReportTable 
          :data="filteredData" 
          :title="'Tabla Contado'" 
          :empty-message="'No hay ventas de contado'"
        />
      </div>

      <!-- Tabla de Contado sin impuesto (purchase_type = 1 y sin impuesto (tax_one_id = 3)) -->
      <div>
        <div class="flex">
          <h2 class="text-2xl font-semibold mb-4 flex-auto">Nota de Venta de Contado 0%</h2>
          <h2 class="text-2xl font-semibold mb-4 flex-auto text-end">
            Total: {{ formatCurrency(
              filteredDataNoTax.map((item) => item.total_sales).reduce( (acc,curr) => acc + curr,0 ) 
            ) }}
          </h2>
        </div>
        
        <ReportTable 
          :data="filteredDataNoTax" 
          :title="'Tabla Contado 0%'" 
          :empty-message="'No hay ventas de contado al 0%'"
        />
      </div>

      <!-- Tabla Facturado (purchase_type = 2) -->
      <div>
        <div class="flex">
          <h2 class="text-2xl font-semibold mb-4 flex-auto">Factura de Contado 16%</h2>
          <h2 class="text-2xl font-semibold mb-4 flex-auto text-end">
            Total: {{ formatCurrency(
              filteredDataF.map((item) => item.total_sales).reduce( (acc,curr) => acc + curr,0 ) 
            ) }}
          </h2>
        </div>
        
        <ReportTable 
          :data="filteredDataF" 
          :title="'Tabla Facturado'" 
          :empty-message="'No hay ventas facturadas'"
        />
      </div>

      <!-- Tabla Facturado (purchase_type = 2) -->
      <div>
        <div class="flex">
          <h2 class="text-2xl font-semibold mb-4 flex-auto">Factura de Contado 0%</h2>
          <h2 class="text-2xl font-semibold mb-4 flex-auto text-end">
            Total: {{ formatCurrency(
              filteredDataFNoTax.map((item) => item.total_sales).reduce( (acc,curr) => acc + curr,0 ) 
            ) }}
          </h2>
        </div>
        
        <ReportTable 
          :data="filteredDataFNoTax" 
          :title="'Tabla Facturado 0%'" 
          :empty-message="'No hay ventas facturadas'"
        />
      </div>

      <!-- Tabla de Zero/Null (purchase_type = 0 o null) -->
      <div>
        <div class="flex">
          <h2 class="text-2xl font-semibold mb-4 flex-auto">Ventas Crédito 16%</h2>
          <h2 class="text-2xl font-semibold mb-4 flex-auto text-end">
            Total: {{ formatCurrency(
              filteredDataZero.map((item) => item.total_sales).reduce( (acc,curr) => acc + curr,0 ) 
            ) }}
          </h2>
        </div>
        <ReportTable 
          :data="filteredDataZero" 
          :title="'Credito'" 
          :empty-message="'No hay ventas sin tipo'"
        />
      </div>

      <div>
        <div class="flex">
          <h2 class="text-2xl font-semibold mb-4">Ventas Crédito 0%</h2>
          <h2 class="text-2xl font-semibold mb-4 flex-auto text-end">
            Total: {{ formatCurrency(
              filteredDataZeroNoTax.map((item) => item.total_sales).reduce( (acc,curr) => acc + curr,0 ) 
            ) }}
          </h2>
        </div>
        
        <ReportTable 
          :data="filteredDataZeroNoTax" 
          :title="'Credito 0%'" 
          :empty-message="'No hay ventas sin tipo'"
        />
      </div>

      <div>
        <div class="flex">
          <h2 class="text-2xl font-semibold mb-4 flex-auto">Clientes Sin Tipo de Compra</h2>
          <h2 class="text-2xl font-semibold mb-4 flex-auto text-end">
            Total: {{ formatCurrency(
              clientDetailsZero.map((item) => item.total_sales).reduce( (acc,curr) => acc + curr,0 ) 
            ) }}
          </h2>
        </div>
        <table class="min-w-full bg-white border border-gray-300">
          <thead>
            <tr>
              <th class="px-4 py-3">Cliente</th>
              <th class="px-4 py-3">Folios</th>
              <th class="px-4 py-3">Total Ventas</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="client in clientDetailsZero" :key="client.client_name">
              <td class="px-4 py-3">{{ client.client_name }}</td>
              <td class="px-4 py-3">{{ client.all_folios }}</td>
              <td class="px-4 py-3">{{ formatCurrency(client.total_sales) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import ReportTable from '@/Components/ReportTable.vue'

export default {
  components: {
    Head,
    Link,
    ReportTable,
  },
  layout: Layout,
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    clientDetailsZero: {
      type: Array,
      default: () => [],
    },
    date: {
      type: String,
    },
    route: {
      type : Array,
    },
    day: {
      type : Array,
    },
  },
  computed: {
    filteredData() {
      // Filtra solo los registros con purchase_type = 1 (Contado) y con IVA (tax_one_id = 1)
      return this.data.filter(item => item.purchase_type === 1 && (item.tax_one_id === 1 || item.tax_one_id === 2) && (item.invoice_required === 'No'))
    },
    filteredDataF() {
      // Filtra solo los registros con purchase_type = 1 y que requieren factura (Facturados)
      return this.data.filter(item => item.purchase_type === 1 && (item.tax_one_id === 1 || item.tax_one_id === 2) && (item.invoice_required === 'Si'))
    },
    filteredDataZero() {
      // Filtra los registros a credito
      return this.data.filter(item => item.purchase_type === 2 && (item.tax_one_id === 1  || item.tax_one_id === 2))
    },
    filteredDataNoTax()
    {
      //Filtra los datos de las órdenes que son en efectivo y que no aplican impuestos
      return this.data.filter(item => item.purchase_type === 1 && item.tax_one_id === 3 && (item.invoice_required === 'No'))
    },
    filteredDataFNoTax()
    {
      //Filtra los datos de las órdenes que son facturados y que no aplican impuestos
      return this.data.filter(item => item.purchase_type === 1 && item.tax_one_id === 3 && (item.invoice_required === 'Si'))
    },
    filteredDataZeroNoTax()
    {
      //Filtra los datos de las órdenes a credito y que no aplican impuestos
      return this.data.filter(item => item.purchase_type === 2 && item.tax_one_id === 3)
    },
  },
  methods: {
    formatCurrency(value) {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value || 0)
    },
    descargarPDF() {
      const date = this.date
      const route = this.route.toString()
      const day = this.day.toString()
      console.log({'date': date,'route':route,'days':day})
      window.location.href = `/liquidation/report/${route}/${date}/${day}?pdf=1`
    },
  },
}
</script>